import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HideFooter, HideHeader, StructuredPageData } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { ProductDetailsPage as ProductDetailsPageV2, useFeatureFlags } from "@sonic-equipment/ui";
import ProductDetailsPageV1 from "@sonic/Overrides/Pages/ProductDetailsPageV1";
import { customerState } from "@sonic/Store/GemecoState";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: customerState) => {
    const location = getLocation(state);
    return {
        pageUrl: location.pathname,
    };
};

type Props = ReturnType<typeof mapStateToProps> & PageProps;

export function ProductDetailsPage({ pageUrl, ...props }: Props) {
    const { pdpV1 } = useFeatureFlags();

    if (pdpV1) {
        // eslint-disable-next-line react/jsx-pascal-case
        return <ProductDetailsPageV1.component pageUrl={pageUrl} {...props} />;
    }
    return <ProductDetailsPageV2 pageUrl={pageUrl} />;
}

const pageModule: PageModule = {
    component: connect(mapStateToProps)(ProductDetailsPage),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsProductSelection: true,
        pageType: "System",
        fieldDefinitions: [StructuredPageData, HideHeader, HideFooter],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "ProductDetailsPage" instead of this constant.
 */
export const ProductDetailsPageContext = "ProductDetailsPage";
